import React, { useEffect, useState } from 'react';
import UserForm from './form';
import { asyncGetProjects } from '../../../services/project.service';
import {
    BodyProject,
    ProjectsList,
} from '../../../shared/types/project.interface';

const UserNew = () => {
    const [projects, setProjects] = useState<ProjectsList[]>([]);
    const [onSave, setOnSave] = useState<boolean>(false);
    useEffect(() => {
        asyncGetProjects().then((body: BodyProject) => {
            if (body.items !== undefined) {
                setProjects(
                    body.items.items.map((item) => ({
                        id: item.id,
                        name: item.nameProject,
                    }))
                );
            }
        });
    }, [onSave]);

    return (
        <UserForm
            projects={projects}
            onSave={(value: any) => setOnSave(value)}
        />
    );
};

export default UserNew;
